export interface NavigationLinks {
  name: string;
  links: {
    name?: string;
    href?: string;
    sublinks?: {
      name: string;
      href: string;
    }[];
  }[];
}

export const navigationLinks: NavigationLinks[] = [
  {
    name: 'footerFooterMenuSectionsTechnologyTitle',
    links: [
      {
        name: 'footerFooterMenuSectionsTechnologyItemsProducts',
        sublinks: [
          {
            name: 'footerFooterMenuSectionsTechnologyItemsDatabasesName',
            href: 'footerFooterMenuSectionsTechnologyItemsDatabasesLink',
          },
          {
            name: 'footerFooterMenuSectionsTechnologyItemsApiSdkName',
            href: 'footerFooterMenuSectionsTechnologyItemsApiSdkLink',
          },
          {
            name: 'footerFooterMenuSectionsTechnologyItemsVectorMapsName',
            href: 'footerFooterMenuSectionsTechnologyItemsVectorMapsLink',
          },
          {
            name: 'footerFooterMenuSectionsTechnologyItems2gisProName',
            href: 'footerFooterMenuSectionsTechnologyItems2gisProLink',
          },
          {
            name: 'footerFooterMenuSectionsTechnologyItemsTelemarketingName',
            href: 'footerFooterMenuSectionsTechnologyItemsTelemarketingLink',
          },
          {
            name: 'footerFooterMenuSectionsTechnologyItemsOnPremiseName',
            href: 'footerFooterMenuSectionsTechnologyItemsOnPremiseLink',
          },
          {
            name: 'footerFooterMenuSectionsTechnologyItemsLensName',
            href: 'footerFooterMenuSectionsTechnologyItemsLensLink',
          },
          {
            name: 'footerFooterMenuSectionsTechnologyItemsPrintName',
            href: 'footerFooterMenuSectionsTechnologyItemsPrintLink',
          },
        ],
      },
      {
        name: 'footerFooterMenuSectionsSolutionsTitle',
        sublinks: [
          {
            name: 'footerFooterMenuSectionsSolutionsItemsBusinessName',
            href: 'footerFooterMenuSectionsSolutionsItemsBusinessLink',
          },
          {
            name: 'footerFooterMenuSectionsSolutionsItemsGovernmentName',
            href: 'footerFooterMenuSectionsSolutionsItemsGovernmentLink',
          },
        ],
      },
      {
        name: 'footerFooterMenuSectionsDevelopersTitle',
        sublinks: [
          {
            name: 'footerMenuPlatformManagerName',
            href: 'https://platform.2gis.ru/?utm_source=dev2gis&utm_medium=futer&utm_campaign=landingPLM',
          },
          {
            name: 'footerFooterMenuSectionsDevelopersItemsDocsName',
            href: 'footerFooterMenuSectionsDevelopersItemsDocsLink',
          },
          {
            name: 'footerFooterMenuSectionsDevelopersItemsStylesEditorName',
            href: 'footerFooterMenuSectionsDevelopersItemsStylesEditorLink',
          },
        ],
      },
      {
        name: 'footerFooterMenuSectionsQualityTitle',
        href: 'footerFooterMenuSectionsQualityLink',
      },
      {
        name: 'footerFooterMenuSectionsCasesTitle',
        href: 'footerFooterMenuSectionsCasesLink',
      },
    ],
  },
  {
    name: 'footerFooterMenuSectionsOtherProductsTitle',
    links: [
      {
        name: 'footerFooterMenuSectionsOtherProductsCategoriesBusinessTitle',
        sublinks: [
          {
            name: 'footerFooterMenuSectionsOtherProductsCategoriesBusinessAdvertisingName',
            href: 'footerFooterMenuSectionsOtherProductsCategoriesBusinessAdvertisingLink',
          },
          {
            name: 'footerFooterMenuSectionsOtherProductsCategoriesBusinessOtelloName',
            href: 'footerFooterMenuSectionsOtherProductsCategoriesBusinessOtelloLink',
          },
        ],
      },
      {
        name: 'footerFooterMenuSectionsOtherProductsCategoriesUsersTitle',
        sublinks: [
          {
            name: 'footerFooterMenuSectionsOtherProductsCategoriesUsersServiceName',
            href: 'footerFooterMenuSectionsOtherProductsCategoriesUsersServiceLink',
          },
          {
            name: 'footerFooterMenuSectionsOtherProductsCategoriesUsersBookingName',
            href: 'footerFooterMenuSectionsOtherProductsCategoriesUsersBookingLink',
          },
        ],
      },
    ],
  },
  {
    name: 'footerFooterMenuSectionsCompanyTitle',
    links: [
      {
        sublinks: [
          {
            name: 'footerFooterMenuSectionsCompanyItemsTechnoName',
            href: 'footerFooterMenuSectionsCompanyItemsTechnoLink',
          },
          {
            name: 'footerFooterMenuSectionsCompanyItemsJobsName',
            href: 'footerFooterMenuSectionsCompanyItemsJobsLink',
          },
          {
            name: 'footerFooterMenuSectionsCompanyItemsFranchiseName',
            href: 'footerFooterMenuSectionsCompanyItemsFranchiseLink',
          },
          {
            name: 'footerFooterMenuSectionsCompanyItemsPartnerName',
            href: 'footerFooterMenuSectionsCompanyItemsPartnerLink',
          },
          {
            name: 'footerFooterMenuSectionsCompanyItemsContactsName',
            href: '#contacts',
          },
        ],
      },
      {
        name: 'footerFooterMenuSectionsNewsTitle',
        sublinks: [
          {
            name: 'footerFooterMenuSectionsNewsItemsPressCenterName',
            href: 'footerFooterMenuSectionsNewsItemsPressCenterLink',
          },
          {
            name: 'footerFooterMenuSectionsNewsItemsNewsName',
            href: 'footerFooterMenuSectionsNewsItemsNewsLink',
          },
          {
            name: 'footerFooterMenuSectionsNewsItemsDeliveryName',
            href: 'footerFooterMenuSectionsNewsItemsDeliveryLink',
          },
        ],
      },
    ],
  },
  {
    name: 'footerFooterMenuSectionsTermsTitle',
    links: [
      {
        sublinks: [
          {
            name: 'footerFooterMenuSectionsTermsItemsLegalInfoName',
            href: 'footerFooterMenuSectionsTermsItemsLegalInfoLink',
          },
          {
            name: 'footerFooterMenuSectionsTermsItemsPrivacyPolicyName',
            href: 'footerFooterMenuSectionsTermsItemsPrivacyPolicyLink',
          },
          {
            name: 'footerFooterMenuSectionsTermsItemsLicenseAgreementName',
            href: 'footerFooterMenuSectionsTermsItemsLicenseAgreementLink',
          },
        ],
      },
      {
        name: 'footerFooterMenuSectionsSocialTitle',
      },
    ],
  },
];
